export interface IntegerResultDTO {
  result: number;
};

export function IntegerResultDTO_EmptyObject(): IntegerResultDTO {
  return {
    result: 0
  }
};
